import React, { useState } from "react";
import FreeCounselingPage from "../home/FreeCounselingPage";

const FEATURES = [
  {
    title: "Custom IT Solutions",
    desc: "Tailored software and technology solutions built around your business needs.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="4" width="18" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.6" fill="none" />
        <path d="M8 20h8M12 16v4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
        <path d="M9.5 9l-2 2 2 2M14.5 9l2 2-2 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
    ),
  },
  {
    title: "Professional Services",
    desc: "End-to-end IT services to help you optimize operations and achieve your business goals.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 8a4 4 0 100 8 4 4 0 000-8z"
          stroke="currentColor"
          strokeWidth="1.6"
          fill="none"
        />
        <path
          d="M19.4 13.5c.05-.5.05-1 0-1.5l1.7-1.3-1.7-3-2 .5c-.4-.35-.85-.65-1.35-.85L15.6 5h-3.2l-.4 2.35c-.5.2-.95.5-1.35.85l-2-.5-1.7 3 1.7 1.3c-.05.5-.05 1 0 1.5l-1.7 1.3 1.7 3 2-.5c.4.35.85.65 1.35.85l.4 2.35h3.2l.4-2.35c.5-.2.95-.5 1.35-.85l2 .5 1.7-3-1.7-1.3z"
          stroke="currentColor"
          strokeWidth="1.4"
          fill="none"
        />
      </svg>
    ),
  },
  {
    title: "Powerful Software Products",
    desc: "Ready-to-use products designed to simplify your operations and drive better results.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2l8 4.5v9L12 20l-8-4.5v-9L12 2z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
          fill="none"
        />
        <path d="M12 11L4 6.5M12 11l8-4.5M12 11v9" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" fill="none" />
      </svg>
    ),
  },
];

const TRUST_ITEMS = [
  {
    label: "No Obligation",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z" stroke="currentColor" strokeWidth="1.6" fill="none" />
      </svg>
    ),
  },
  {
    label: "Quick Response",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" fill="none" />
        <path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
      </svg>
    ),
  },
  {
    label: "100% Confidential",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="11" width="16" height="9" rx="2" stroke="currentColor" strokeWidth="1.6" fill="none" />
        <path d="M8 11V7a4 4 0 118 0v4" stroke="currentColor" strokeWidth="1.6" fill="none" />
      </svg>
    ),
  },
];

const RocketIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09z" stroke="currentColor" strokeWidth="1.6" fill="none" />
    <path d="M12 15l-3-3a22 22 0 012-3.95A12.88 12.88 0 0122 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 01-4 2z" stroke="currentColor" strokeWidth="1.6" fill="none" />
    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" stroke="currentColor" strokeWidth="1.6" fill="none" />
    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" stroke="currentColor" strokeWidth="1.6" fill="none" />
  </svg>
);

const CTA = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <section className="cta-section">
        <div className="cta-overlay"></div>

        <div className="cta-grid">
          {/* LEFT — message */}
          <div className="cta-left">
            <span className="cta-eyebrow">Let's Build Solutions Together</span>

            <h2 className="cta-heading">
              Powering Businesses with <span className="cta-highlight">Smart IT Solutions</span>
            </h2>

            <p className="cta-subtext">
              We deliver innovative IT services and powerful software products
              that help businesses automate, optimize and grow.
            </p>

            <div className="cta-features">
              {FEATURES.map((f, i) => (
                <div className="cta-feature" key={i}>
                  <div className="cta-feature-icon">{f.icon}</div>
                  <div>
                    <div className="cta-feature-title">{f.title}</div>
                    <div className="cta-feature-desc">{f.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT — action panel */}
          <div className="cta-right">
            <div className="cta-panel">
              <div className="cta-panel-icon">
                <RocketIcon />
              </div>

              <div className="cta-panel-eyebrow">Let's Get Started</div>
              <div className="cta-panel-title">
                Have a project in mind? Let's build it together.
              </div>
              <p className="cta-panel-sub">
                Let's discuss your requirements and find the right solution
                for your business.
              </p>

              <button
                type="button"
                className="cta-button cta-button-blink"
                onClick={() => setShowModal(true)}
              >
                Discuss Your Project
                <span className="cta-button-arrow">→</span>
              </button>

              <div className="cta-trust-row">
                {TRUST_ITEMS.map((t, i) => (
                  <div className="cta-trust-item" key={i}>
                    <div className="cta-trust-icon">{t.icon}</div>
                    <span>{t.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MODAL */}
      {showModal && (
        <div className="custom-modal-backdrop">
          <div className="custom-modal">
            <button className="close-btn" onClick={() => setShowModal(false)}>
              ×
            </button>
            <FreeCounselingPage onClose={() => setShowModal(false)} />
          </div>
        </div>
      )}

      {/* CSS */}
      <style>{`
        .cta-section {
          position: relative;
          overflow: hidden;
          background: linear-gradient(160deg, #0d0420 0%, #150836 50%, #1a0a42 100%);
          width: 100%;
          padding: 36px 0;
        }

        .cta-overlay {
          position: absolute;
          top: -140px;
          right: -120px;
          width: 420px;
          height: 420px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(168,85,247,0.22), transparent 70%);
          z-index: 1;
        }

        .cta-grid {
          position: relative;
          z-index: 2;
          max-width: 1180px;
          margin: 0 auto;
          padding: 0 40px;
          display: grid;
          grid-template-columns: 1.3fr 1fr;
          gap: 36px;
          align-items: center;
        }

        /* ── LEFT ── */
        .cta-left {
          text-align: left;
        }

        .cta-eyebrow {
          display: block;
          color: #b98cf0;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          margin-bottom: 6px;
        }

        /* ── UNIFIED HEADING ── */
        .cta-heading {
          font-family: 'Outfit', sans-serif;
          font-size: clamp(2.1rem, 4vw, 3rem);
          font-weight: 800;
          line-height: 1.15;
          color: #fff;
          margin: 0 0 12px;
        }

        .cta-highlight {
          color: #6c0a9f;
        }

        /* ── UNIFIED SUBHEADING ── */
        .cta-subtext {
          font-family: 'Inter', sans-serif;
          font-size: 15.5px;
          font-weight: 400;
          color: #d8cdea;
          line-height: 1.75;
          margin: 0 0 18px;
          max-width: 460px;
        }

        .cta-features {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .cta-feature {
          display: flex;
          align-items: flex-start;
          gap: 12px;
        }

        .cta-feature-icon {
          width: 34px;
          height: 34px;
          min-width: 34px;
          border-radius: 50%;
          background: rgba(168, 85, 247, 0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #c084fc;
        }

        .cta-feature-icon svg {
          width: 16px;
          height: 16px;
        }

        .cta-feature-title {
          font-family: 'Outfit', sans-serif;
          color: #f1eafb;
          font-size: 13.5px;
          font-weight: 700;
          margin-bottom: 1px;
        }

        .cta-feature-desc {
          font-family: 'Inter', sans-serif;
          color: #a495c2;
          font-size: 12px;
          line-height: 1.4;
        }

        /* ── RIGHT ── */
        .cta-right {
          display: flex;
          justify-content: center;
        }

        .cta-panel {
          width: 100%;
          max-width: 340px;
          border: 1px solid rgba(168, 85, 247, 0.25);
          border-radius: 16px;
          background: rgba(255, 255, 255, 0.03);
          padding: 20px 22px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .cta-panel-icon {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background: rgba(168, 85, 247, 0.18);
          color: #c084fc;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 8px;
        }

        .cta-panel-icon svg {
          width: 20px;
          height: 20px;
        }

        .cta-panel-eyebrow {
          color: #d8b4fe;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          margin-bottom: 6px;
        }

        .cta-panel-title {
          font-family: 'Outfit', sans-serif;
          color: #fff;
          font-size: 16px;
          font-weight: 800;
          line-height: 1.3;
          margin-bottom: 5px;
        }

        .cta-panel-sub {
          font-family: 'Inter', sans-serif;
          color: #c9bede;
          font-size: 12.5px;
          line-height: 1.4;
          margin: 0 0 14px;
        }

        .cta-button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 100%;
          background: linear-gradient(90deg, #7c3aed, #a855f7);
          color: #fff;
          border: none;
          padding: 11px 20px;
          border-radius: 9px;
          font-size: 13.5px;
          font-weight: 700;
          cursor: pointer;
          transition: transform 0.25s ease;
          box-shadow: 0 6px 18px rgba(124, 58, 237, 0.35);
        }

        .cta-button:hover {
          transform: translateY(-2px);
        }

        .cta-button-blink {
          animation: cta-blink 1.6s ease-in-out infinite;
        }

        @keyframes cta-blink {
          0%, 100% {
            opacity: 1;
            box-shadow: 0 0 0 0 rgba(168, 85, 247, 0.55);
          }
          50% {
            opacity: 0.82;
            box-shadow: 0 0 0 10px rgba(168, 85, 247, 0);
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .cta-button-blink {
            animation: none;
          }
        }

        .cta-button-arrow {
          font-size: 15px;
        }

        .cta-trust-row {
          display: flex;
          justify-content: space-between;
          gap: 6px;
          width: 100%;
          margin-top: 14px;
          padding-top: 12px;
          border-top: 1px solid rgba(168, 85, 247, 0.2);
        }

        .cta-trust-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;
          flex: 1;
          color: #c9bede;
          font-size: 10px;
          font-weight: 600;
        }

        .cta-trust-icon {
          color: #c084fc;
        }

        .cta-trust-icon svg {
          width: 15px;
          height: 15px;
        }

        .custom-modal-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .custom-modal {
          background: #fff;
          width: 95%;
          max-width: 520px;
          max-height: 85vh;
          overflow-y: auto;
          border-radius: 12px;
          padding: 30px;
          position: relative;
        }

        .close-btn {
          position: absolute;
          top: 10px;
          right: 14px;
          font-size: 22px;
          background: none;
          border: none;
          cursor: pointer;
        }

        @media (max-width: 900px) {
          .cta-grid {
            grid-template-columns: 1fr;
            gap: 24px;
          }

          .cta-right {
            justify-content: stretch;
          }

          .cta-panel {
            max-width: 100%;
          }
        }

        @media (max-width: 640px) {
          .cta-section {
            padding: 26px 0;
          }

          .cta-grid {
            padding: 0 20px;
          }

          .cta-left {
            text-align: center;
          }

          .cta-subtext {
            margin-left: auto;
            margin-right: auto;
          }

          .cta-heading {
            font-size: clamp(1.7rem, 7vw, 2.1rem);
          }

          .cta-feature {
            justify-content: center;
            text-align: left;
          }
        }
      `}</style>
    </>
  );
};

export default CTA;